/** @prettier */
import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { useInterval } from "../../util/useInterval";

function secondsUntil(until: Date) {
    return Math.round((until.getTime() - Date.now()) / 1000);
}

function padNumber(num: number) {
    return Math.abs(num) < 10 ? `0${num}` : num.toString();
}

function formatTime(time: number) {
    const minutes = Math.floor(Math.abs(time) / 60);
    const seconds = Math.abs(time % 60);
    return `${time < 0 ? "-" : ""}${padNumber(minutes)}:${padNumber(seconds)}`;
}

type TestTimerProps = {
    deadline: Date;
    dispatch: (action: { event: "timeExpired" }) => void;
};
export const TestTimer = ({ deadline, dispatch }: TestTimerProps) => {
    const [secondsRemaining, setSecondsRemaining] = useState(() =>
        secondsUntil(deadline),
    );

    // Update the clock at a regular interval
    useInterval(() => {
        setSecondsRemaining(secondsUntil(deadline));
    }, 500);

    const urgent = secondsRemaining < 60;

    useEffect(() => {
        if (secondsRemaining <= 0) {
            dispatch({ event: "timeExpired" });
        }
    });

    return (
        <div className={classnames("tr-timer", { urgent })}>
            {formatTime(secondsRemaining)}
        </div>
    );
};
